import { Http } from '@mygpt/app/http';

export interface CreateDictionaryParams {
  aiId: string;
  source: string;
  target: string;
}
/**
 * 创建字典
 * @param params
 * @returns
 */
export const createDictionaryService = (params: CreateDictionaryParams) => {
  const { post } = Http.use();
  return post(`/robots/${params.aiId}/dictionaries`, [{ source: params.source, target: params.target }]);
};
